<template>
<div id="zero" 
    class="welcome d-flex justify-content-center flex-column " 
    style="z-index: 0; height:100vh; min-height:500px; background-size:cover; background-image:url(/static/7777-Landing.jpg);"
    :style="{ 'background-image': 'url(/static/7777-Landing.jpg)'}">
    <div style="z-index: 1; position: absolute; top: 0; left: 0; width: 100vw; height: 100vh;" :style="{ background: customizeData.ColorHex, opacity: 0.3 }"></div>
  <div class="container" style="z-index: 2;">
    <div class="inner-wrapper mt-auto mb-auto container">
      <div class="row">
        <div class="col-xs-7">
          <h1 id="LandingMessage" class="welcome-heading display-4 text-white">{{ customizeData.LandingMessage }}</h1>
          <p id= "LandingText" class="text-white" v-html="customizeData.LandingText"></p>
          <a @click="startButtonClicked" id="start" v-bind:style="{ background: customizeData.ColorHex }" class="btn btn-lg  btn-pill align-self-center" style="color:white; float: left;" v-html="customizeData.ButtonStart"></a>
        </div>
      </div>
    </div>
  </div>
  
</div> 
</template>


<script>
export default {
  name: "IntroView",
  data() {
    return {
      customizeData : {},
      companyID: "-1",
      noAccessURL: process.env.NOACCESSURL,
      rootURL: "D:/InetPub/WWWRoot/"
    };
  },
  methods: {
    onLoad: function() 
    {
      var otevurl = this.$route.params.otevurl;

      if(otevurl)
      {
        this.$http.get(this.noAccessURL + 'otevurl.php?otevurl=' + otevurl).then(response => {
          this.companyID = response.body.CompanyID;
          if(this.companyID != "-1")
          {
            console.log(this.companyID);

            this.$http.get(this.noAccessURL + 'getAppointment.php?action=personalize&companyId=' + this.companyID).then(response => {
              this.customizeData = response.body[0];
              console.log(response.body);

              //console.log(this.customizeData);
            }, response => 
            {
              console.log("ERROR: " + response);
            });
          }
        }, response => 
        {
          console.log("ERROR: " + response);
        });
      }



    },
    startButtonClicked: function()
    {
      this.$router.push({name: 'MainView', params: {customizeData: this.customizeData, companyID: this.companyID}});
    }
  },
  beforeMount() {
    this.onLoad();
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#LandingText
{
  text-align: left;
  margin-left: 15px;
}

#LandingMessage
{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/IntroView.vue